import { Component, Inject, Input, OnInit } from '@angular/core';
import { DialogContentData } from '../generic-dialog/generic-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GamerecordService } from '../gamerecord.service';
import { GameRecord } from 'diwimamodelweb';

@Component({
  selector: 'app-game-origin-form-dialog',
  templateUrl: './game-origin-form-dialog.component.html',
  styleUrls: ['./game-origin-form-dialog.component.css']
})
export class GameOriginFormDialogComponent implements OnInit {
  gameOriginForm: FormGroup
  templateDataForm: FormGroup
  // @Input() formBuilder: FormBuilder
  gameOriginDataFields:any 
  templatesList:any = []
  gameRecordData: GameRecord = new GameRecord
  gameRecordValues:any 
  infoGameRecord:any = {
    hunter:'Unknown',
    tagid:'NO tag-ID',
    species:'Unknown'
  }

  constructor(
    public dialogRef: MatDialogRef<GameOriginFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContentData,
    private grService: GamerecordService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

    if(this.data?.data){
      this.templatesList = this.data.data.templates
      this.gameRecordData.setFromAny(this.data.data.values)
      this.gameRecordValues = this.data.data.form
      if(this.gameRecordData?.tagid)
        this.infoGameRecord.tagid = this.gameRecordData?.tagid

      if(this.gameRecordData?.erlegerAnzeigeName)
        this.infoGameRecord.hunter = this.gameRecordData?.erlegerAnzeigeName


      if(this.gameRecordData?.wildart)
      this.infoGameRecord.species = this.gameRecordData?.wildart

    }

    this.gameOriginForm = this.formBuilder.group({
      template:[],
      data:[],
      border_top:[],
      border_left:[]
    })

    this.templateDataForm = this.formBuilder.group({ })

    this.gameOriginForm.get('template').valueChanges.subscribe( value => {
      const data = this.grService.unzipFile(value)
    })


    this.grService.selectedTemplateGameOriginSubject$.subscribe( value => {
      this.updateRowsSectionForform(value)

    })

  }

  onCancle() {
    if (this.data.cancleCallback) {
      this.data.cancleCallback()
    }
    this.dialogRef.close()
  }

  onConfirm() {
    if (this.data.positiveCallback) {
      
      const data = {
        template: this.gameOriginForm.value.template,
        formData:this.templateDataForm.value
      }
      this.data.positiveCallback(data)
      this.gameOriginForm.patchValue({})
    }
    this.dialogRef.close()
  }

  updateRowsSectionForform(value){
    this.templateDataForm = this.formBuilder.group({ })

    if(value){
      if(value.type=='json'){
        this.gameOriginDataFields = value.data?.formSections

        if(this.gameOriginDataFields){
          this.gameOriginDataFields.forEach(section => {
            section.rows.forEach(row => {
              if(row.key)
              this.templateDataForm.addControl(row.key, this.formBuilder.control(undefined));
            });
            
          });
        }
      }
      if(value.type=='xml'){
        const fieldsAllValues = value.data?.plist?.array?.dict?.array?.dict
        const values = {
          [value.data?.plist?.array?.dict?.key[0]]:value.data?.plist?.array?.dict?.string,
          [value.data?.plist?.array?.dict?.key[1]]:value.data?.plist?.array?.dict?.array?.dict

        }
        let allfieldds=[]
        fieldsAllValues.forEach(row => {
          let info= {}
            if(row?.key.length === row?.string.length){
              row.key.forEach((field, index) => {
                info[field] =  row?.string[index]
                if(field=='key')
                this.templateDataForm.addControl(row?.string[index], this.formBuilder.control(undefined));
              });
            }
            allfieldds.push(info)            
        });
        this.gameOriginDataFields = [{rows:allfieldds}]

      }
        this.gameOriginForm.patchValue({data: value.data})

    }

  }

}
